import { __rest } from '../../_virtual/_tslib.js';
import React, { useContext } from 'react';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { LabelPresentation } from '../Label/LabelPresentation.js';

var A11yMeaningfulLabelContext = /*#__PURE__*/React.createContext({
  onMouseHoverChange: function onMouseHoverChange() {},
  onKeyboardFocusChange: function onKeyboardFocusChange() {},
  onMouseDown: function onMouseDown() {},
  onMouseUp: function onMouseUp() {},
  onMouseLeave: function onMouseLeave() {},
  hasMouseHover: false,
  hasKeyboardFocus: false,
  disabled: false,
  loading: false
});
var A11yMeaningfulLabelPresentation = function A11yMeaningfulLabelPresentation(_a) {
  var htmlAttrs = _a.htmlAttrs,
    props = __rest(_a, ["htmlAttrs"]);
  var _b = useContext(A11yMeaningfulLabelContext),
    type = _b.type,
    actionContext = __rest(_b, ["type"]);
  return type === "link" ? /*#__PURE__*/React.createElement(ActionPresentation, Object.assign({}, props, actionContext, {
    expandToOverlay: true,
    isDisplayInline: true,
    htmlAttrs: htmlAttrs
  })) : /*#__PURE__*/React.createElement(LabelPresentation, Object.assign({}, props, actionContext, {
    expandToOverlay: true,
    isDisplayInline: true,
    htmlFor: actionContext.htmlFor,
    htmlAttrs: htmlAttrs
  }));
};
A11yMeaningfulLabelPresentation.displayName = "A11yMeaningfulLabelPresentation";

export { A11yMeaningfulLabelContext, A11yMeaningfulLabelPresentation };
